import React, { useEffect, useState } from "react";
import {
  Button,
  Modal,
  Form,
  Input,
  Table,
  Select,
  Typography,
  Flex,
  message,
} from "antd";
import dayjs from "dayjs";
import { SendOutlined, PlusOutlined } from "@ant-design/icons";
import type { ColumnsType } from "antd/es/table";
import { CSSProperties } from "react";
import { DatePicker, TimePicker, Card, Badge } from "antd";
import type { Dayjs } from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import { AddDrivercall, fetchCall } from "src/redux/actions/DriverCallAction";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import CustomTableLoader from "src/components/common/CustomTableLoader";

interface CabEntry {
  cabId: string;
  driverName: string;
  datetime: string;
  reason: string;
  remarks: string;
}
const { TextArea } = Input;
const CabForm: React.FC = () => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { Option } = Select;
  const { Title, Text } = Typography;
  dayjs.extend(isSameOrAfter);
  dayjs.extend(isSameOrBefore);
  const [isModalVisible, setIsModalVisible] = useState(false);
  // const [dataSource, setDataSource] = useState<CabEntry[]>([]);
  const [currentDateTime, setCurrentDateTime] = useState("");
  const userData = JSON.parse(localStorage.getItem("userData") || "{}");

  const [searchText, setSearchText] = useState("");
  const [fromDate, setFromDate] = useState<Dayjs | null>(dayjs());
  const [toDate, setToDate] = useState<Dayjs | null>(dayjs());

  const [fromTime, setFromTime] = useState<Dayjs | null>(null);
  const [toTime, setToTime] = useState<Dayjs | null>(null);
  // const [loading, setLoading] = useState(false);
   const loading = useSelector(
      (state: any) => state.drivercall.loading
    );

  const dataSource = useSelector((state: any) =>
    Array.isArray(state.drivercall.data) ? state.drivercall.data : [],
  );
  const update = useSelector((state: any) => state.drivercall.create);

  useEffect(() => {
    const today = dayjs().format("YYYY-MM-DD");
    dispatch(fetchCall(today, today));
  }, []);

  useEffect(() => {
    if (update?.success) {
      const today = dayjs().format("YYYY-MM-DD");
      dispatch(fetchCall(today, today));
      // dispatch(fetchCall(today, today));
    }
  }, [update?.success]);

  const handleFetch = () => {
    if (fromDate && toDate) {
      const from = fromDate.format("YYYY-MM-DD");
      const to = toDate.format("YYYY-MM-DD");

      dispatch(fetchCall(from, to));
      console.log(dataSource);
    } else {
      message.warning("Please select both From and To dates.");
    }
  };

  const onFinish = (values: any) => {
    // setLoading(true);
    const payload = {
      cabId: values.cabId,
      reason: values.reason,
      remarks: values.remarks || "",
      type: values.type,
      updateBy: userData.employeename,
    };

    dispatch(AddDrivercall(payload));

    form.resetFields();
    setIsModalVisible(false);
  };

  const filteredData = dataSource.filter((item: any) => {
    const itemDateTime = dayjs(item.date);

    const searchMatch =
      item.cabId?.toLowerCase().includes(searchText.toLowerCase()) ||
      item.driverName?.toLowerCase().includes(searchText.toLowerCase()) ||
      item.reason?.toLowerCase().includes(searchText.toLowerCase()) ||
      item.remarks?.toLowerCase().includes(searchText.toLowerCase());

    const dateMatch =
      (!fromDate || itemDateTime.isSameOrAfter(fromDate.startOf("day"))) &&
      (!toDate || itemDateTime.isSameOrBefore(toDate.endOf("day")));

    const timeMatch =
      (!fromTime || itemDateTime.format("HH:mm") >= fromTime.format("HH:mm")) &&
      (!toTime || itemDateTime.format("HH:mm") <= toTime.format("HH:mm"));

    return searchMatch && dateMatch && timeMatch;
  });

  const disableFutureDates = (current: any) => {
    return current && current > dayjs().endOf("day");
  };

  const disableToDate = (current: any) => {
    if (!fromDate) return disableFutureDates(current);
    return (
      (current && current < fromDate.startOf("day")) ||
      (current && current > dayjs().endOf("day"))
    );
  };

  const showModal = () => {
    const now = dayjs().format("DD-MM-YYYY  &  HH:mm:ss");
    setCurrentDateTime(now);
    setIsModalVisible(true);
  };
  const handleCancel = () => {
    setIsModalVisible(false);
    form.resetFields();
  };
  // const handleOk = () => {
  //   form
  //     .validateFields()
  //     .then((values) => {
  //       const newEntry: CabEntry = {
  //         ...values,
  //         datetime: currentDateTime,
  //       };
  //       setDataSource((prev) => [...prev, newEntry]);
  //       setIsModalVisible(false);
  //       form.resetFields();
  //     })
  //     .catch((err) => {
  //       console.log("Validation Failed:", err);
  //     });
  // };
  const headerCellStyle: CSSProperties = {
    backgroundColor: "lightblue",
    fontSize: "15px",
    textAlign: "center",
  };
  const fieldStyle: CSSProperties = {
    border: "1px solid #ccc",
    borderRadius: "4px",
    padding: "10px",
    height: "0px",
  };
  const inputStyle: React.CSSProperties = {
    border: "none",
    background: "transparent",
    outline: "none",
    boxShadow: "none",
    padding: 0,
    fontSize: "15px",
    height: "30px",
  };
  const columns: ColumnsType<CabEntry> = [
    {
      title: "Cab ID",
      dataIndex: "cabId",
      key: "cabId",
      align: "center",
      width: 100,
    },
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      align: "center",
      width: 150,
      render: (date: string) => dayjs(date).format("DD-MM-YYYY"),
    },
    {
      title: "Time",
      dataIndex: "date",
      key: "time",
      align: "center",
      width: 100,
      render: (date: string) => dayjs(date).format("hh:mm A"),
    },
    {
      title: "Reason",
      dataIndex: "reason",
      key: "reason",
      align: "center",
    },
    {
      title: "Remarks",
      dataIndex: "remarks",
      key: "remarks",
      align: "center",
    },
    {
      title: "Call type",
      dataIndex: "type",
      key: "type",
      align: "center",
    },
    {
      title: "Updated By",
      dataIndex: "updateBy",
      key: "updateBy",
      align: "center",
    },
  ];
  return (
    <div
      style={{ backgroundColor: "whitesmoke", minHeight: "100vh", padding: 20 }}
    >
      <Flex style={{ width: "50%", justifyContent: "start" }}>
        <Title
          level={3}
          style={{
            fontSize: "35px",
            fontWeight: "bolder",
            color: "black",
            fontFamily: "serif",
            textShadow: "2px 2px 5px rgba(0, 0, 0, 0.3)",
            margin: 0,
          }}
        >
          Driver Calls
        </Title>
      </Flex>
      <div style={{ width: "100%", display: "flex", flexDirection: "row" }}>
        <div style={{ display: "flex", gap: 12, marginTop: 20, width: "50%" }}>
          <DatePicker
            value={fromDate}
            placeholder="From Date"
            onChange={(date) => setFromDate(date)}
            style={{ height: "35px" }}
            disabledDate={disableFutureDates}
          />

          <DatePicker
            value={toDate}
            placeholder="To Date"
            onChange={(date) => setToDate(date)}
            disabledDate={disableToDate}
            style={{ height: "35px" }}
          />

          <Button
            type="primary"
            style={{ backgroundColor: "#884299" }}
            onClick={handleFetch}
          >
            Go
          </Button>

          <TimePicker
            use12Hours
            format="hh:mm A"
            placeholder="From Time"
            onChange={(time) => setFromTime(time)}
            style={{ height: "35px" }}
          />

          <TimePicker
            use12Hours
            format="hh:mm A"
            placeholder="To Time"
            onChange={(time) => setToTime(time)}
            style={{ height: "35px" }}
          />
          {/* <Button type="primary" style={{ backgroundColor: "#884299" }}>
            Go
          </Button> */}
        </div>
        <div
          style={{
            display: "flex",
            gap: 12,
            marginTop: 20,
            width: "50%",
            justifyContent: "end",
          }}
        >
          <Card style={{ width: "200px" }} size="small">
            {/* <Badge count={filteredData.length} showZero> */}
            <span style={{ fontWeight: 600 }}>
              Total Records - {filteredData.length}
            </span>
            {/* </Badge> */}
          </Card>
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={showModal}
            style={{ backgroundColor: "#884299" }}
          >
            Add
          </Button>
          <Input.Search
            placeholder="Search"
            allowClear
            onChange={(e) => setSearchText(e.target.value)}
            style={{ width: 250 }}
          />
        </div>
      </div>
      <Table
        dataSource={filteredData}
        columns={columns}
        rowKey={(record, index) => `${record.cabId}-${index}`}
        style={{ marginTop: 20, backgroundColor: "#fff" }}
        bordered
        loading={{
          spinning: loading,
          indicator: <CustomTableLoader />,
        }}
      />
      <Modal
        open={isModalVisible}
        onCancel={handleCancel}
        footer={null}
        title={
          <div
            style={{
              backgroundColor: "purple",
              color: "white",
              textAlign: "center",
              padding: "10px 0",
              borderRadius: "4px",
              fontSize: "15px",
              fontWeight: "bold",
              marginTop: "20px",
            }}
          >
            Add Driver Calls
          </div>
        }
        // modalRender={(modalNode) => (
        //   <div
        //     style={{
        //       border: "4px solid rgb(102, 99, 99)",
        //       borderRadius: "10px",
        //       marginTop: "5px",
        //       backgroundColor: "white",
        //       boxShadow: "5px 5px 5px rgba(27, 11, 241, 0.3)",
        //     }}
        //   >
        //     {modalNode}
        //   </div>
        // )}
      >
        {/* <div
          style={{
            backgroundColor: "purple",
            color: "white",
            textAlign: "center",
            padding: "10px 0",
            borderRadius: "50px",
            fontSize: "15px",
            fontWeight: "bold",
            marginTop: "20px",
          }}
        >
          Add Driver Calls
        </div> */}

        <Form
          form={form}
          onFinish={onFinish}
          layout="horizontal"
          labelCol={{ span: 7 }}
          wrapperCol={{ span: 14 }}
        >
          <Form.Item
            name="cabId"
            label="CabId"
            rules={[{ required: true, message: "Please enter Cab ID" }]}
          >
            <Input placeholder="" />
          </Form.Item>
          {/* <br />
          <br /> */}
          {/* <fieldset style={fieldStyle}>
            <legend
              style={{
                fontWeight: "bold",
                width: "100px",
                borderBottom: "none",
                color: "black",
              }}
            >
              Date & Time
            </legend>
            <div
              style={{
                padding: "4px 11px",
                borderRadius: "4px",
                marginTop: "-30px",
              }}
            >
              {currentDateTime}
            </div>
          </fieldset> */}
          <Form.Item
            name="type"
            label="Call Type"
            rules={[{ required: true, message: "Please select a reason" }]}
          >
            <Select placeholder="Select reason" style={{ width: "100%" }}>
              <Option value="incoming">Incoming</Option>
              <Option value="outgoing">Outgoing</Option>
            </Select>
          </Form.Item>

          <Form.Item
            name="reason"
            label="Reason"
            rules={[{ required: true, message: "Please select a reason" }]}
          >
            <Select placeholder="Select reason" style={{ width: "100%" }}>
              <Option value="Amount change">Amount change</Option>
              <Option value="Login Request">Login Request</Option>
              <Option value="Amount clarification">Amount clarification</Option>
              <Option value="Weekly statement">Weekly statement</Option>
              <Option value="Credit Request">Credit Request</Option>
              <Option value="Subscription Request">Subscription Request</Option>
              <Option value="GST Invoice">GST Invoice</Option>
              <Option value="Payment Message not Received">
                Payment Message not Received
              </Option>
              <Option value="Paid call">Paid call</Option>
              <Option value="Low revenue">Low revenue</Option>
              <Option value="FOC">FOC</Option>
              <Option value="Weekly Amount">Weekly Amount</Option>
              <Option value="QR Code">QR Code</Option>
              <Option value="Revert">Revert</Option>
              <Option value="Others">Others</Option>
            </Select>
          </Form.Item>

          <Form.Item name="remarks" label="Remarks">
            <TextArea rows={2} placeholder="" style={{ resize: "none" }} />
          </Form.Item>

          <Form.Item wrapperCol={{ span: 24 }}>
            <div style={{ textAlign: "center", marginTop: "16px" }}>
              <Button
                type="primary"
                htmlType="submit"
                icon={<SendOutlined />}
                style={{ backgroundColor: "green" }}
                loading={loading}
              >
                Save
              </Button>
            </div>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};
export default CabForm;
